export async function getOrganization() {
  try {
    const response = await fetch("/api/organization");
    if (!response.ok) {
      throw new Error("Failed to fetch organization");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("[getOrganization] Failed to fetch organization:", {
      error: error instanceof Error ? error.message : "Unknown error",
    });
    throw error;
  }
}
